// frontend/src/components/PrivateRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import VerifyEmailNotice from "./Home/VerifyEmailNotice";

const PrivateRoute = () => {
  const { userInfo, authLoading } = useContext(AuthContext);

  if (authLoading) return null; // or a loading spinner

  if (!userInfo) return <Navigate to="/login" replace />;

  // Mirrors the backend: only the "user" role must be verified
  const role = userInfo.role || "user";
  if (role === "user" && !userInfo.verified) return <VerifyEmailNotice />;

  return <Outlet />;
};

export default PrivateRoute;
